.signet-tooltip {
  &:not(.disabled) {
    position: relative;
    display: inline-block;

    .text {
      transition: all 0.3s ease-in-out;

      &:hover {
        & + .message {
          visibility: visible;
          opacity: 1;
        }
      }
    }

    .message {
      visibility: hidden;
      text-align: center;
      min-width: fit-content;
      white-space: nowrap;
      font-weight: normal;
      position: absolute;
      opacity: 0;
      background-color: var(--gray-500);
      padding: 6px 8px;
      z-index: 50;
      transition: all 0.3s ease-in-out;
      border-radius: 4px;
      color: var(--pure-white);
      font-size: 12px;

      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: var(--gray-500);
        transform: rotate(-45deg) !important;
        z-index: 10 !important;
        border-radius: 1px;
      }

      &.top {
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 4px;

        &::before {
          top: 50%;
          left: 50%;
          transform: translateX(-50%);
        }

        &::after {
          top: 70%;
          left: 40%;
          transform: translateX(-50%);
        }
      }

      &.bottom {
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 4px;

        &::before {
          bottom: 50%;
          left: 50%;
          transform: translateX(-50%);
        }

        &::after {
          bottom: 80%;
          left: 40%;
          transform: translateX(-50%);
          margin-bottom: -2px;
        }
      }

      &.left {
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 10px;

        &::before {
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
        }

        &::after {
          left: 91%;
          top: 29%;
          transform: translateY(-50%);
          // margin-left: -2px;
        }
      }

      &.right {
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 10px;

        &::before {
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
        }

        &::after {
          right: 91%;
          top: 29%;
          transform: translateY(-50%);
          // margin-right: -2px;
        }
      }

      &.size {
        &-sm {
          width: 10rem;
        }

        &-md {
          width: 15rem;
        }

        &-lg {
          width: 20rem;
        }

        &-xl {
          width: 25rem;
        }
      }
    }

    &.show {
      .message {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}
